import { useState } from "react";
import CopyCode from "../CopyCode/CopyCode";
import Icon from "../Icon";

const ButtonComponents = () => {
	const [clickedButton, setClickedButton] = useState(null);
	const [isLoading, setIsLoading] = useState(null);

	const handleClick = (id) => {
		setClickedButton(id);
		setTimeout(() => setClickedButton(null), 200);
	};

	return (
		<div className="flex flex-col gap-y-10 p-6">
			{/* SECTION 1: BUTTON STYLES */}
			<div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
				<h2 className="text-xl font-bold text-white mb-6">Button Styles</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">

					{/* Variation 1: Primary Solid */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Primary Solid</label>
						<div className="flex gap-3 flex-wrap">
							<button className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold rounded-lg transition-all">
								Click Me
							</button>
								<button className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-all">
								Default
							</button>
							<button className="px-4 py-2 bg-amber-700 hover:bg-amber-800 text-white font-semibold rounded-lg transition-all">
								Dark
							</button>
						</div>
								<CopyCode number_code={1} code={`<button className="px-4 py-2 bg-amber-500 hover:bg-amber-600 text-slate-900 font-semibold rounded-lg transition-all">
  Click Me
</button>`} />
					</div>

					{/* Variation 2: Secondary Outline */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Outline Buttons</label>
						<div className="flex gap-3 flex-wrap">
							<button className="px-4 py-2 border-2 border-slate-400 text-slate-300 hover:border-slate-200 hover:text-slate-100 rounded-lg transition-all font-semibold">
								Outline
							</button>
							<button className="px-4 py-2 border-2 border-amber-400 text-amber-400 hover:bg-amber-400/10 rounded-lg transition-all font-semibold">
								Cyan
							</button>
								<button className="px-4 py-2 border-2 border-amber-400 text-amber-400 hover:bg-amber-400/10 rounded-lg transition-all font-semibold">
								Purple
							</button>
						</div>
								<CopyCode number_code={2} code={`<button className="px-4 py-2 border-2 border-amber-400 text-amber-400 hover:bg-amber-400/10 rounded-lg transition-all font-semibold">
  Amber
</button>`} />
					</div>

					{/* Variation 3: Ghost Buttons */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Ghost Buttons</label>
						<div className="flex gap-3 flex-wrap">
							<button className="px-4 py-2 text-slate-400 hover:text-slate-100 hover:bg-slate-700/50 rounded-lg transition-all font-semibold">
								Ghost 1
							</button>
							<button className="px-4 py-2 text-amber-400 hover:text-amber-300 hover:bg-amber-400/10 rounded-lg transition-all font-semibold">
								Ghost 2
							</button>
								<button className="px-4 py-2 text-amber-400 hover:text-amber-300 hover:bg-amber-400/10 rounded-lg transition-all font-semibold">
								Ghost 3
							</button>
						</div>
								<CopyCode number_code={3} code={`<button className="px-4 py-2 text-amber-400 hover:text-amber-300 hover:bg-amber-400/10 rounded-lg transition-all font-semibold">
  Ghost
</button>`} />
					</div>

					{/* Variation 4: Gradient Buttons */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Gradient Buttons</label>
						<div className="flex gap-3 flex-wrap">
								<button className="px-4 py-2 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold rounded-lg transition-all">
									Amber to Orange
							</button>
							<button className="px-4 py-2 bg-gradient-to-r from-amber-500 to-amber-500 hover:from-amber-600 hover:to-amber-600 text-white font-semibold rounded-lg transition-all">
								Amber to Amber
							</button>
						</div>
								<CopyCode number_code={4} code={`<button className="px-4 py-2 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold rounded-lg transition-all">
	Amber to Orange
</button>`} />
					</div>

					{/* Variation 5: With Icons */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Icon Buttons</label>
						<div className="flex gap-3 flex-wrap">
								<button className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white rounded-lg font-semibold flex items-center gap-2 transition-all">
									<Icon name="folder" className="w-4 h-4" /> Save
							</button>
								<button className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white rounded-lg font-semibold flex items-center gap-2 transition-all">
								<Icon name="search" className="w-4 h-4" /> Search
							</button>
								<button className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white rounded-lg font-semibold flex items-center gap-2 transition-all">
								<Icon name="star" className="w-4 h-4" /> Star
							</button>
						</div>
						<CopyCode number_code={5} code={`<button className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white rounded-lg font-semibold flex items-center gap-2 transition-all">
	<span>Icon</span> Save
</button>`} />
					</div>

					{/* Variation 6: Full Width */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Full Width</label>
						<div className="space-y-2">
								<button className="w-full px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-all">
								Full Width Button
							</button>
								<button className="w-full px-4 py-2 border-2 border-amber-400 text-amber-400 hover:bg-amber-400/10 font-semibold rounded-lg transition-all">
								Full Width Outline
							</button>
						</div>
						<CopyCode number_code={6} code={`<button className="w-full px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-all">
  Full Width Button
</button>`} />
					</div>

				</div>
			</div>

			{/* SECTION 2: BUTTON STATES & INTERACTIONS */}
			<div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
				<h2 className="text-xl font-bold text-white mb-6">Button States</h2>
				<div className="grid grid-cols-1 md:grid-cols-2 gap-4">

					{/* Variation 7: Different Sizes */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Size Variants</label>
						<div className="flex items-center gap-2 flex-wrap">
							<button className="px-2 py-1 text-xs bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded transition-all">
								XS
							</button>
								<button className="px-3 py-1 text-sm bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded transition-all">
								Small
							</button>
								<button className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-all">
								Default
							</button>
								<button className="px-6 py-3 text-lg bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg transition-all">
								Large
							</button>
						</div>
						<CopyCode number_code={7} code={`<!-- XS -->
<button className="px-2 py-1 text-xs bg-amber-600 rounded">XS</button>

<!-- Small -->
<button className="px-3 py-1 text-sm bg-amber-600 rounded">Small</button>

<!-- Large -->
<button className="px-6 py-3 text-lg bg-amber-600 rounded-lg">Large</button>`} />
					</div>

					{/* Variation 8: Disabled States */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Disabled States</label>
						<div className="flex gap-3 flex-wrap">
								<button className="px-4 py-2 bg-amber-600 text-white font-semibold rounded-lg disabled:opacity-50 disabled:cursor-not-allowed" disabled>
								Disabled
							</button>
								<button className="px-4 py-2 border-2 border-amber-400 text-amber-400 font-semibold rounded-lg disabled:opacity-50 disabled:cursor-not-allowed" disabled>
								Disabled Outline
							</button>
							<button className="px-4 py-2 bg-amber-600 text-white font-semibold rounded-lg opacity-50 cursor-not-allowed">
								Unavailable
							</button>
						</div>
						<CopyCode number_code={8} code={`<button className="px-4 py-2 bg-amber-600 text-white font-semibold rounded-lg disabled:opacity-50 disabled:cursor-not-allowed" disabled>
  Disabled
</button>`} />
					</div>

					{/* Variation 9: Active/Pressed States */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Active States</label>
						<div className="flex gap-3 flex-wrap">
							<button 
								onClick={() => handleClick('btn1')}
								className={`px-4 py-2 font-semibold rounded-lg transition-all ${
									clickedButton === 'btn1' 
												? 'bg-amber-800 scale-95 ring-4 ring-amber-400'
												: 'bg-amber-600 hover:bg-amber-700'
								} text-white`}
							>
								Press Me
							</button>
								<button className="px-4 py-2 bg-amber-600 hover:bg-amber-700 active:bg-amber-800 active:scale-95 active:ring-4 active:ring-amber-400 text-white font-semibold rounded-lg transition-all">
								Active
							</button>
						</div>
						<CopyCode number_code={9} code={`<button className="px-4 py-2 bg-amber-600 hover:bg-amber-700 active:bg-amber-800 active:scale-95 active:ring-4 active:ring-amber-400 text-white font-semibold rounded-lg transition-all">
  Press Me
</button>`} />
					</div>

					{/* Variation 10: Loading State */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Loading States</label>
						<div className="flex gap-3 flex-wrap">
							<button 
								onClick={() => {
									setIsLoading('load1');
									setTimeout(() => setIsLoading(null), 2000);
								}}
								disabled={isLoading === 'load1'}
								className="px-4 py-2 bg-amber-600 hover:bg-amber-700 disabled:opacity-60 text-white font-semibold rounded-lg flex items-center gap-2 transition-all"
							>
								{isLoading === 'load1' ? (
									<>
										<Icon name="settings" className="w-4 h-4 inline-block animate-spin" /> Loading
									</>
								) : (
									'Submit'
								)}
							</button>
							<button className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold rounded-lg flex items-center gap-2 transition-all">
								<Icon name="dot" className="w-4 h-4 inline-block animate-pulse" /> Processing
							</button>
						</div>
						<CopyCode number_code={10} code={`<button 
  disabled={isLoading}
  className="px-4 py-2 bg-amber-600 text-white rounded-lg flex items-center gap-2"
>
  {isLoading ? (
    <>
	<span className="inline-block animate-spin">Loading</span>
    </>
  ) : (
    'Submit'
  )}
</button>`} />
					</div>

					{/* Variation 11: Hover Effects */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Hover Effects</label>
						<div className="flex gap-3 flex-wrap">
								<button className="px-4 py-2 bg-amber-600 text-white font-semibold rounded-lg hover:shadow-lg hover:shadow-amber-500/50 hover:scale-105 transition-all">
								Glow+Scale
							</button>
								<button className="px-4 py-2 bg-amber-600 text-white font-semibold rounded-lg hover:-translate-y-1 hover:shadow-lg transition-all">
								Lift
							</button>
								<button className="px-4 py-2 bg-amber-600 text-white font-semibold rounded-lg hover:skew-y-1 transition-all">
								Skew
							</button>
						</div>
						<CopyCode number_code={11} code={`<button className="px-4 py-2 bg-amber-600 text-white rounded-lg hover:shadow-lg hover:shadow-amber-500/50 hover:scale-105 transition-all">
  Glow+Scale
</button>`} />
					</div>

					{/* Variation 12: Button Groups */}
					<div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
						<label className="text-xs text-slate-400 mb-3 block font-medium">Button Groups</label>
						<div className="flex gap-0 flex-wrap border border-slate-500 rounded-lg overflow-hidden">
								<button className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white font-semibold border-r border-slate-600 transition-all">
								First
							</button>
							<button className="px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white font-semibold border-r border-slate-600 transition-all">
								Second
							</button>
							<button className="px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white font-semibold transition-all">
								Third
							</button>
						</div>
						<CopyCode number_code={12} code={`<div className="flex gap-0 border border-slate-500 rounded-lg overflow-hidden">
  <button className="px-4 py-2 bg-amber-600 border-r border-slate-600">First</button>
  <button className="px-4 py-2 bg-slate-700 border-r border-slate-600">Second</button>
  <button className="px-4 py-2 bg-slate-700">Third</button>
</div>`} />
					</div>

				</div>
			</div>
		</div>
	);
};

export default ButtonComponents;



